module.exports = __webpack_public_path__ + "static/productive-7ef7a7de9f169cc2ca6930ce0817e2fb.png";